import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 24",
  height: "48",
  width: "48",
  class: "yb-svg-icon"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("g", null, [
      _createElementVNode("path", {
        d: "M0,19.59a4,4,0,0,0,4,4H20a4,4,0,0,0,4-4V17.72a1.23,1.23,0,1,0-2.45,0v1.87A1.59,1.59,0,0,1,20,21.18H4a1.59,1.59,0,0,1-1.59-1.59V17.72a1.23,1.23,0,1,0-2.45,0Z",
        fill: "currentColor"
      }),
      _createElementVNode("path", {
        d: "M12,19.32a2,2,0,0,0,2-2V8.2A.25.25,0,0,1,14.21,8H16.9a1,1,0,0,0,.74-1.62L12.74.7a1,1,0,0,0-1.48,0L6.36,6.33A1,1,0,0,0,7.1,8H9.79A.25.25,0,0,1,10,8.2v9.16A2,2,0,0,0,12,19.32Z",
        fill: "currentColor"
      })
    ], -1)
  ])))
}
export default { render: render }